import './social_content_context_view.js.coffee';# Added by Script 
Monitoring.Views ||= {}

class Monitoring.Views.SocialContentParentPostView extends Monitoring.Views.SocialContentContextView

  initialize: (@options = {}) ->
    super(@options)
    @$resultsContainer = @$el.find('#parent_post')

  noResultsMessage: ->
    'POST NOT FOUND'